'use strict';

const TOOLTIP = '.more-info-tooltip';

function closeAll() {
	$(TOOLTIP).removeClass('is-open').attr('aria-expanded', 'false');
}

module.exports = function () {
	$(document).on('click', TOOLTIP, function (e) {
		e.preventDefault();

		let $tooltip = $(this);
		let isOpen = !$tooltip.hasClass('is-open');

		closeAll();
		$tooltip.toggleClass('is-open', isOpen).attr('aria-expanded', String(isOpen));
	});

	// <span role="button"> variants (checkout, order detail) need Enter/Space like a native button
	$(document).on('keydown', 'span' + TOOLTIP, function (e) {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			$(this).trigger('click');
		}
	});

	$(document).on('click', function (e) {
		if (!$(e.target).closest(TOOLTIP).length) {
			closeAll();
		}
	});
};
